import { useCurrencies } from "@/queries/currencies.query.ts";
import { useRecent } from "@/hooks/use-recent.hook.ts";
import { ApiRecentKey } from "@/types/recents/recents.types.ts";
import { Multiselect, Select, SelectItem } from "@skailer-com/uikit";
import { ComponentProps, useMemo } from "react";
import { useTranslation } from "react-i18next";

type CurrencySelectProps =
  | (Omit<
      ComponentProps<typeof Select>,
      "options" | "recentOptions" | "recentLabel" | "isMulti"
    > & {
      isMulti?: false;
    })
  | (Omit<
      ComponentProps<typeof Multiselect>,
      "options" | "recentOptions" | "recentLabel" | "isMulti"
    > & {
      isMulti: true;
    });

export function CurrencySelect({ isLoading, ...props }: CurrencySelectProps) {
  const { t } = useTranslation();
  const { data: currencies, isLoading: isCurrenciesLoading } = useCurrencies();
  const { getRecentOptions } = useRecent();

  const options = useMemo<SelectItem[]>(
    () => currencies?.map((x) => ({ id: x.code, title: x.code })) ?? [],
    [currencies]
  );

  const sharedProps = {
    options,
    recentOptions: getRecentOptions(ApiRecentKey.currency, options),
    recentLabel: t("common:recent"),
    isLoading: isLoading ?? isCurrenciesLoading,
  };
  if (props.isMulti) {
    return <Multiselect {...props} {...sharedProps} />;
  }
  return <Select {...props} {...sharedProps} />;
}
